import { MouseEvent, useState } from 'react'
import { useSelector } from 'utils/hooks'
import { Divider } from '@jisr-hr/ds-beta'
import { MultiGroupSelectlist } from 'components/global'
import useFilterAPI from '../useFilterAPI'
import { useFilters } from './context'
import { getTranslatedList } from '../helper'
import FilterBoxHeader from '../FilterBox/FilterBoxHeader'

type RequestTypesProps = {
  filterKey: string
  filters: Array<string>
  title: string
}

const SingleRequestType = (props: RequestTypesProps): JSX.Element => {
  const { company } = useSelector(({ auth }) => auth)
  const { request_type, request_type_list, archived_request_type_list } = useFilterAPI()
  const { filter, setFilter } = useFilters()
  const isSupportCustomRequests = company?.subscribed_features?.includes('custom_requests')
  const { filters, title, filterKey } = props

  const [isCollapsed, setIsCollapsed] = useState(false)

  let optionList = getTranslatedList(request_type, 'name')

  if (isSupportCustomRequests) {
    const resList = [...request_type_list, ...archived_request_type_list].map((r) => ({
      ...r,
      group: 'custom_requests',
      testId: `cusom_request_${r.id}`,
    }))
    optionList = [...optionList, ...resList]
  }

  const onChange = (val: string): void => {
    setFilter({
      ...filter,
      single_request_type: val,
    })
  }

  const handleClear = (e: MouseEvent<HTMLButtonElement>): void => {
    e.stopPropagation()
    setFilter({
      ...filter,
      single_request_type: undefined,
      request_type_id: undefined,
    })
  }

  return (
    <div>
      <div className="flex flex-col px-6 py-4 gap-4">
        <FilterBoxHeader
          canShowClear={filter?.single_request_type}
          handleClearFilter={handleClear}
          handleCollabseFilterBox={(): void => setIsCollapsed(!isCollapsed)}
          isCollapsed={isCollapsed}
          title="label.request_type"
        />
        {!isCollapsed && (
          <>
            <MultiGroupSelectlist
              list={optionList}
              value={filter?.single_request_type}
              onChange={(data) => onChange(data?.value ?? '')}
              labelKey="name_i18n"
              valueKey="id"
              groupKey="group"
            />
          </>
        )}
      </div>
      {![filterKey, title].includes(filters[filters.length - 1]) && <Divider />}
    </div>
  )
}

export default SingleRequestType
